import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import usePageTitle from "./lib/usePageTitle";

function TitleManager() {
  usePageTitle();
  return null;
}

import Landing from "./pages/Landing";
import ChiSiamo from "./pages/ChiSiamo";
import Perche from "./pages/Perche";
import PercheDiventarePartner from "./pages/PercheDiventarePartner";
import Gallery from "./pages/Gallery";
import NotFound from "./pages/NotFound";
import PropertyDetail from "./pages/PropertyDetail";
import Agencies from "./pages/Agencies";
import LeadForm from "./pages/LeadForm";
import Login from "./pages/Login";

import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import AgenciesAdmin from "./pages/admin/AgenciesAdmin";
import TechniciansAdmin from "./pages/admin/TechniciansAdmin";
import PropertiesAdmin from "./pages/admin/PropertiesAdmin";
import PropertyFascicolo from "./pages/admin/PropertyFascicolo";
import SellersAdmin from "./pages/admin/SellersAdmin";
import Leads from "./pages/admin/Leads";
import AuditLog from "./pages/admin/AuditLog";
import RichiesteDocumentazione from "./pages/admin/RichiesteDocumentazione";
import RegistroRichieste from "./pages/admin/RegistroRichieste";

import AgenziaLogin from "./pages/agenzie/AgenziaLogin";
import AgenziaPasswordReset from "./pages/agenzie/AgenziaPasswordReset";
import AgenziaFirstLogin from "./pages/agenzie/AgenziaFirstLogin";
import AgenziaLayout from "./pages/agenzie/AgenziaLayout";
import AgenziaDashboard from "./pages/agenzie/AgenziaDashboard";
import AgenziaImmobili from "./pages/agenzie/AgenziaImmobili";
import AgenziaLead from "./pages/agenzie/AgenziaLead";
import AgenziaProfilo from "./pages/agenzie/AgenziaProfilo";
import AgenziaDocumentazione from "./pages/agenzie/AgenziaDocumentazione";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <TitleManager />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/perche" element={<Perche />} />
            <Route path="/perche-diventare-partner" element={<PercheDiventarePartner />} />
            <Route path="/galleria" element={<Gallery />} />
            <Route path="/immobile/:id" element={<PropertyDetail />} />
            <Route path="/agenzie" element={<Agencies />} />
            <Route path="/form" element={<LeadForm />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="agenzie" element={<AgenciesAdmin />} />
              <Route path="tecnici" element={<TechniciansAdmin />} />
              <Route path="immobili" element={<PropertiesAdmin />} />
              <Route path="immobili/:id" element={<PropertyFascicolo />} />
              <Route path="venditori" element={<SellersAdmin />} />
              <Route path="leads" element={<Leads />} />
              <Route path="registro-richieste" element={<RegistroRichieste />} />
              <Route path="richieste-documentazione" element={<RichiesteDocumentazione />} />
              <Route path="audit" element={<AuditLog />} />
            </Route>
            <Route path="/area-agenzie/login" element={<AgenziaLogin />} />
            <Route path="/area-agenzie/reset-password" element={<AgenziaPasswordReset />} />
            <Route path="/area-agenzie/primo-accesso" element={<AgenziaFirstLogin />} />
            <Route path="/area-agenzie" element={<AgenziaLayout />}>
              <Route index element={<AgenziaDashboard />} />
              <Route path="immobili" element={<AgenziaImmobili />} />
              <Route path="richieste" element={<AgenziaLead />} />
              <Route path="documentazione" element={<AgenziaDocumentazione />} />
              <Route path="profilo" element={<AgenziaProfilo />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
